/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusImpersonationProtokollDto } from '../../models/lexplus-impersonation-protokoll-dto';
import { LexplusStartImpersonationDto } from '../../models/lexplus-start-impersonation-dto';

export interface ImpersonationControllerStartV1$Params {
      body: LexplusStartImpersonationDto
}

export function impersonationControllerStartV1(http: HttpClient, rootUrl: string, params: ImpersonationControllerStartV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusImpersonationProtokollDto>> {
  const rb = new RequestBuilder(rootUrl, impersonationControllerStartV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusImpersonationProtokollDto>;
    })
  );
}

impersonationControllerStartV1.PATH = '/v1/impersonation/start';
